// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Minus from "@awc/XDL/Icons/Minus";
import Plus from "@awc/XDL/Icons/Plus";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xBaseTheme } from "@awc/XDL/types";
import { color } from "@awc/XDL/Utilities";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import ChevronUp from "@insite/mobius/Icons/ChevronUp";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
    },
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        mergeCss: true,
        titleTypographyProps: {
            weight: fontConfig.weight.bold,
            size: 15,
            css: css`
                letter-spacing: 0;
                line-height: 18px;
                margin-bottom: 0;
            `,
        },
        toggleIconProps: {
            color: "primary",
            src: Minus,
            size: 14,
        },
        expandIconProps: {
            color: "common.white",
            src: Plus,
            width: 14,
            height: 13,
        },
        headerProps: {
            css: css`
                background: ${color("common.white")};
                padding: 0;
                border: 1px solid ${color("common.black")};
                border-top: 0;
                &:first-of-type {
                    border-top: 1px solid ${color("common.black")};
                }
                &&& button {
                    background: transparent;
                    padding: 8px 12px;
                    border: none;
                    ${TypographyStyle} {
                        color: ${color("primary")};
                    }
                }
                &&& button:focus {
                    padding: 8px 12px;
                }
                &&& button:focus-visible {
                    ${TypographyStyle} {
                        outline: 1px solid ${color("primary")};
                    }
                }

                ${({ expanded }: AccordionSectionHeaderProps) =>
                    !expanded &&
                    css`
                        background: ${color("primary")};

                        &&& button,
                        &&& button:focus {
                            background: transparent;

                            ${TypographyStyle} {
                                color: ${color("common.white")};
                            }
                        }
                        &&& button:focus-visible {
                            ${TypographyStyle} {
                                outline: 1px solid ${color("common.white")};
                            }
                        }
                    `}
            `,
        },
        panelProps: {
            css: css`
                border: 1px solid ${color("common.black")};
                border-top: 0;
                padding: 10px 12px;
                font-size: ${fontConfig.fontSize.regular};
                letter-spacing: 0;
                line-height: ${fontConfig.lineHeight.singleLineRegular};
            `,
        },
    },
} as xBaseTheme["accordion"];
